/* eslint-disable @typescript-eslint/no-explicit-any */
import httpClient from "@/services/index";
import type { CourtOrderDependentPayloadType } from "@/types";
import { API_ENDPOINTS } from "./endpoints";

export type LoginParams = {
  username: string;
  password: string;
  loginGroupId: string;
  groupId: string;
};

export type ILoginResponse = {
  message: string;
  signature: string;
  is_mfa_enabled: boolean;
  success: boolean;
  status: string;
};

export const login = async (params: LoginParams) => {
  const { username, password, loginGroupId, groupId } = params;
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: API_ENDPOINTS.LOGIN,
    headers: {
      "Accept-Version": "1.0",
    },
    data: {
      loginGroupId,
      username,
      password,
      groupId,
    },
  };
  return httpClient.request(config).then((response) => response.data);
};

export const demographics = async (userInfo: {
  groupId: string;
  divisionId: string;
  accessToken: string;
}) => {
  const data = {
    groupId: userInfo.groupId,
    divisionId: userInfo.divisionId,
  };

  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: "/member/demographics",
    headers: {
      Authorization: `Bearer ${userInfo.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "4.0",
    },
    data,
  };
  return httpClient.request(config).then((response) => {
    return response.data.result;
  });
};

export const fetchCourtOrderedDependents = async (
  payload: CourtOrderDependentPayloadType,
) => {
  const url = API_ENDPOINTS.COURT_ORDER_DEPENDENTS;
  const { accessToken, ...rest } = payload;
  const params = {
    ...rest,
  };
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  return httpClient.post(url, params, config).then((res) => res.data);
};

export const globalFlags = async (userInfo: any) => {
  const url = `/home/globalFlag`;
  const params = {
    memberId: userInfo.memberId,
    groupId: userInfo.groupId,
    divisionId: userInfo.divisionId,
  };
  const config = {
    params,
    headers: {
      Authorization: `Bearer ${userInfo.accessToken}`,
      "Accept-Version": "1.0",
    },
  };
  return httpClient.get(url, config).then((res) => res.data);
};

export const providerNetworkType = async (userInfo: any) => {
  const url = "/member/providerNetworkType";

  const data = {
    memberId: userInfo.memberId,
    groupId: userInfo.groupId,
    divisionId: userInfo.divisionId,
    planId: userInfo.planId,
  };
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url,
    headers: {
      Authorization: `Bearer ${userInfo.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
    },
    data,
  };

  return httpClient.request(config).then((response) => response.data);
};
